import clsx from 'clsx';
import { Loader2 } from 'lucide-react';
import React from 'react';

const Spinner = ({ size = 20, className = '' }: { size?: number; className?: string }) => {
  return (
    <Loader2
      className={clsx("animate-spin text-primary-accent", className)}
      size={size}
      strokeWidth={2}
    />
  );
};

export default Spinner;
